import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";

Vue.use(Vuetify);
@Component({
  name: "InfoModalTemplate"
})
export default class InfoModalTemplate extends Vue {
  @Prop() private dialogModalInfo = false;
  @Prop() private modalText!: string;
  @Prop() private modalTitle!: string;
  @Prop({ default: () => false }) button!: boolean;

  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;

  close() {
    this.$emit(LIST_DATA_EVENTS.INFO_MODAL_TEMPLATE_CLOSE);
  }
}
